import { put, select, takeEvery, takeLatest, call } from 'redux-saga/effects';
import { cloneDeep } from "lodash";
import ActionTypes from "../constants/deck";
import { config, leadDeckUrls } from '../config';
const accessToken = () => localStorage.getItem('access_token');
const roomScreenShotsSelector = (state) => state.wizard.roomScreenShots;

function* getMaterialDeckdata(action: any) {
    try {
        const { projectId } = action.result;
        const projectDataJson = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}/api/v1.0/project/${projectId}`,
            { headers: { "Authorization": yield select(accessToken) } }
        );
        let projectData = yield projectDataJson.json();

        const { materialDeckUrl, customer } = projectData || {};
        localStorage.setItem('catalogueProfile', customer?.catalogueProfile || '')

        if (!projectData?.floors?.[0]) {
            throw new Error(`Project data missing floors (status may be ${projectData?.status || 'unknown'})`);
        }

        let floorId = projectData.floors[0].id;
        for(let i=0; i<projectData.floors[0].rooms?.length; i++){
            let roomData = projectData.floors[0].rooms[i];
            yield call(getScreenshots, {projectId, floorId, roomData})
        }
        const data = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}/api/v1.0/project/${projectId}/materialDeckData`,
            { headers: { "Authorization": yield select(accessToken) } });
        let result = yield data.json();

        if (materialDeckUrl) {
            result = {
                ...result,
                materialDeckUrl,
            };
        }
        
        try {
            const rfqResponse = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}/api/v1/rfq/${projectId}`, {
                headers: { "Authorization": yield select(accessToken) }
            });
            const rfqJson = yield rfqResponse.json();
            const rfqDetails = [];
            if (Array.isArray(rfqJson)) {
                const rfqAuthToken = yield select(accessToken);
                for (const rfqEntry of rfqJson) {
                    if (rfqEntry?.addedToSC && rfqEntry?.rfqId) {
                        try {
                            const rfqDetailsResponse = yield fetch(`${process.env.REACT_APP_RFQ_BACKEND_URL}/api/rfqs/${rfqEntry.rfqId}/details`, {
                                headers: { "Authorization": rfqAuthToken }
                            });
                            const rfqDetailsJson = yield rfqDetailsResponse.json();
                            rfqDetails.push(rfqDetailsJson);
                        } catch (rfqDetailsError) {
                            console.error("Failed to fetch RFQ details", rfqDetailsError);
                        }
                    }
                }
            }

            result = {
                ...result,
                rfqData: rfqDetails,
            };
        } catch (rfqError) {
            // If RFQ call fails, continue without blocking deck generation
            console.error("Failed to fetch RFQ data", rfqError);
        }
        
        if(!result.errorId){
            const response = yield processResult(result).then((data) => {
                return data
            }).catch((error) => {
                console.log("Fetch deck fail ", error)
                console.log("error")
            })
            if (response) {
                // Convert JSON to string
                const jsonStr = JSON.stringify(response);
    
                // Search and replace old domain with new domain
                const oldDomain = "https://diqo3k74ktdb.cloudfront.net";
                const newDomain = "https://hl-nucleus-dev.s3.ap-south-1.amazonaws.com";
                const modifiedStr = jsonStr.replace(new RegExp(oldDomain, 'g'), newDomain);
    
                // Convert modified string back to JSON
                const modifiedJsonData = JSON.parse(modifiedStr);
                yield put({
                    type: ActionTypes.FETCH_MATERIAL_DECK_DATA_SUCCESS,
                    result: modifiedJsonData
                });
                yield put({
                    type: ActionTypes.SET_LOADER,
                    result: {
                        isLoading: false,
                        msg: ""
                    }
                })
            } else if (result?.error) {
                yield put({
                    type: ActionTypes.FETCH_MATERIAL_DECK_DATA_FAIL,
                    result: {}
                })
            }
        }else{
            yield put({
                type: ActionTypes.FETCH_MATERIAL_DECK_DATA_FAIL,
                result: {}
            })
            yield put({
                type: ActionTypes.SET_LOADER,
                result: {
                    isLoading: false,
                    msg: ""
                }
            })
        }
    } catch (e) {
        console.log("Fetch deck fail ", e)
        yield put({
            type: ActionTypes.FETCH_MATERIAL_DECK_DATA_FAIL,
            result: {}
        })
    }
}

async function fetchImageOrBlank(url: string) {
    if (!url) return "";
    try {
        const response = await fetch(url);
        return response.ok ? url : "";
    } catch (error) {
        return "";
    }
}

async function processResult(result) {
    //sorting the data based on room type
    const data = result?.roomSlides;
    if (!data || data.length === 0) {
        return result;
    }

    const order = ["Livingroom", "Kitchen", "Bedroom", "Bathroom"];
    data.sort((a, b) => {
        const indexA = order.indexOf(a.roomType);
        const indexB = order.indexOf(b.roomType);
        return indexA - indexB;
    });

    result.indexSlides = data.map((room) => room.name);
    result.roomSlides = [...data];

    for (let roomIndex = 0; roomIndex < result.roomSlides.length; roomIndex++) {
        const room = result.roomSlides[roomIndex];
        const rawAccessorySlides = room?.internalAccessorySlides || [];

        if (room?.viewSlides?.length > 0) {
            room.viewSlides = room.viewSlides.filter((url: string) => !url?.includes('_Zones_'));
        }

        if (rawAccessorySlides.length > 0) {
            room.internalAccessorySlides = await Promise.all(
                rawAccessorySlides.map(async (item) => {
                    const itemData = item.data || [];
                    const uniqueAccessories = itemData.filter((accData, index, array) =>
                        index === array.findIndex((obj) => obj.annotation === accData.annotation)
                    );
                    return {
                        img: item.img,
                        slideHeader: item.slideHeader,
                        data: await Promise.all(
                            uniqueAccessories.map(async (accData) => ({
                                ...accData,
                                qty: itemData.filter((obj) => obj.annotation === accData.annotation).length,
                                img: await fetchImageOrBlank(accData.img),
                            }))
                        ),
                    };
                })
            );
        }

        if (room?.appliancesDataSlides?.data?.length > 0) {
            room.appliancesDataSlides.data = await Promise.all(
                room.appliancesDataSlides.data.map(async (item) => ({
                    ...item,
                    img: await fetchImageOrBlank(item.img),
                }))
            );
        }

        //room indexing
        if (!['Kitchen', 'Bathroom'].includes(room?.roomType)) {
            let roomIndexData = room?.overViewSlides.map((moduleData) => moduleData.slideSubTitle);
            roomIndexData = roomIndexData.concat(room.roomIndexSlide.filter(item => !roomIndexData.includes(item)));
            room.roomIndexSlide = [...roomIndexData];
        }

        for (let moduleIndex = 0; moduleIndex < (room?.overViewSlides?.length || 0); moduleIndex++) {
            const moduleData = room.overViewSlides[moduleIndex];

            //rearrange data based on keys inside object
            let membraneRoutedShutterFinish = false;
            let membraneGrooveShutterFinish = false;
            let membraneBoxit18ShutterFinish = false;
            const rearrangedData = moduleData?.modules.map(obj => {
                let {
                    unit,
                    shutterMaterialAndFinish,
                    shutterColor,
                    carcassMaterialAndFinish,
                    carcassColor,
                    handle,
                    noHandle
                } = obj;
                handle = noHandle === "true" || !handle ? "Handle in customer scope" : handle;
                if (shutterMaterialAndFinish.includes('Membrane Routed')) {
                    membraneRoutedShutterFinish = true
                }
                if (shutterMaterialAndFinish.includes('Membrane Groove')) {
                    membraneGrooveShutterFinish = true
                }
                if (shutterMaterialAndFinish.includes('18 Boxit')) {
                    membraneBoxit18ShutterFinish = true
                }
                return {
                    unit,
                    shutterMaterialAndFinish,
                    shutterColor,
                    carcassMaterialAndFinish,
                    carcassColor,
                    handle
                };
            });

            //remove redundant data in module data
            const filteredData = rearrangedData.filter((item, index, array) => {
                // Check if the current item is the first occurrence of its combination of properties
                return (
                    index ===
                    array.findIndex(
                        (obj) =>
                            obj.unit === item.unit &&
                            obj.carcassColor === item.carcassColor &&
                            obj.carcassMaterialAndFinish === item.carcassMaterialAndFinish &&
                            obj.shutterColor === item.shutterColor &&
                            obj.shutterMaterialAndFinish === item.shutterMaterialAndFinish &&
                            obj.handle === item.handle
                    )
                );
            });
            const accessories = rawAccessorySlides.filter(item => item.name.includes(moduleData.slideSubTitle));

            const uniqueColours = (moduleData?.colours || []).filter((item, index, array) =>
                index === array.findIndex(
                    (obj) =>
                        obj.code === item.code &&
                        obj.img === item.img &&
                        obj.name === item.name
                )
            );
            const colorsFilteredData = await Promise.all(
                uniqueColours.map(async (item) => ({
                    ...item,
                    img: await fetchImageOrBlank(item.img),
                }))
            );

            const uniqueHandles = (moduleData?.handles || []).filter((item, index, array) =>
                index === array.findIndex((obj) => obj.name === item.name)
            );
            const handlesFilteredData = await Promise.all(
                uniqueHandles.map(async (item) => ({
                    ...item,
                    img: await fetchImageOrBlank(item.img),
                }))
            );

            room.overViewSlides[moduleIndex] = {
                ...moduleData,
                modules: filteredData,
                colours: colorsFilteredData,
                handles: handlesFilteredData,
                accessories: accessories || [],
                membraneRoutedShutterFinish,
                membraneGrooveShutterFinish,
                membraneBoxit18ShutterFinish,
            };
        }
    }

    return result;
}

function* generateDeckTimestamp(action: any){
    try {
        const { projectId } = action.result;
        const data = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}/api/v1.0/project/${projectId}/materialDeckGenerationTimestamp`,
            {
                method: 'POST',
                headers: { "Authorization": yield select(accessToken) } 
            });
        let result = yield data.json();
        
        yield put({
            type: ActionTypes.DECK_TIMESTAMP_GENERATION_SUCCESS,
            result
        });
    } catch (e) {
        yield put({
            type: ActionTypes.DECK_TIMESTAMP_GENERATION_FAIL,
            result: {}
        })
    }
}

function* saveDeckLog(action){
    try {
        const { projectId } = action.result;
        const data = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}/api/v1.0/project/${projectId}/materialDeckLog`,
            {
                method: 'POST',
                headers: { 
                    "Authorization": yield select(accessToken),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(action.result)
            });
        let result = yield data.json();
        
        yield put({
            type: ActionTypes.DECK_LOG_SUCCESS,
            result
        });
    } catch (e) {
        yield put({
            type: ActionTypes.DECK_LOG_FAIL,
            result: {}
        })
    }
}

function* updateMaterialDeckUrlSaga(action){
    try{
        const { projectId, pptId } = action.result || {};
        if(!projectId || !pptId){
            throw new Error('Missing projectId or pptId');
        }
        const response = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}/api/v1.0/project/${projectId}/updateMaterialDeckUrl`, {
            method: 'PUT',
            headers: {
                "Authorization": yield select(accessToken),
                "Content-Type": "application/json",
                "x-project-id": projectId
            },
            body: JSON.stringify(pptId)
        });

        if(!response.ok){
            const errorText = yield response.text();
            throw new Error(errorText || 'Failed to update material deck URL');
        }

        yield put({
            type: ActionTypes.UPDATE_MATERIAL_DECK_URL_SUCCESS,
            result: { projectId, pptId }
        });
    }catch(e){
        console.error('Error updating material deck URL', e);
        const errorMessage = e instanceof Error ? e.message : 'Error updating material deck URL';
        yield put({
            type: ActionTypes.UPDATE_MATERIAL_DECK_URL_FAIL,
            result: { projectId: action?.result?.projectId, error: errorMessage }
        })
    }
}

function verifyLeadDeckImages() {
    return new Promise((resolve) => {
        const fetchPromises = Object.keys(leadDeckUrls).map(i => 
            fetch(leadDeckUrls[i])
                .then((response) => {
                    if (!response.ok) {
                        return { [i]: '' };
                    }
                    return { [i]: leadDeckUrls[i] };
                })
                .catch((error) => {
                    return { [i]: '' };
                })
        );

        Promise.all(fetchPromises)
            .then(results => {
                const finalResult = results.reduce((acc, curr) => ({ ...acc, ...curr }), {});
                resolve(finalResult);
            })
            .catch(error => {
                console.error('Error verifying lead deck images:', error);
                resolve({});
            });
    });
}

function* handleLeadDeckImages(action){
    try{
        const result = yield call(verifyLeadDeckImages);
        if(result){
            yield put({
                type: ActionTypes.LEAD_DECK_IMAGES_CHECK_SUCCESS,
                result
            })
        }
    }catch(e){
        console.log(e)
    }
}

function* getScreenshots(action) {
    const { projectId, floorId, roomData } = action;
    try {
        const roomScreenShots = yield select(roomScreenShotsSelector);
        const result = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}/api/v1.0/project/${projectId}/floors/${floorId}/rooms/${roomData.id}/roomImage`,
            { headers: { "Authorization": yield select(accessToken) } });
        let formattedData = getRoomImage(yield result.json());

      yield put({
        type: ActionTypes.GET_SCREENSHOTS_SUCCESS,
        result: {...roomScreenShots, [roomData.id] : {...formattedData, roomName: roomData.name, roomType: roomData.roomType }},
      });
    } catch (e) {
      yield put({
        type: ActionTypes.GET_SCREENSHOTS_FAIL,
        result: '',
        error: { 'error': 'Error in getting room image data' },
      });
    }
  }

  function getRoomImage(result) {
    let finalResults = [], manual = [], auto = [], raytraced = [];
    Object.values(result).forEach((data) => { 
      let res = checkDataType(data, 'imageName'); 
      finalResults = finalResults.concat(res);
    })
    finalResults.forEach((imageObj) => {
      if (imageObj.hasOwnProperty('automationType') && imageObj['imageUrl']) {
        if (imageObj['automationType'] === 'AUTO') {
          if(imageObj?.imageName?.includes('raytraced')) {
            raytraced = raytraced.concat(imageObj);
          } else {
            auto = auto.concat(imageObj);
          }
        } else {
          manual = manual.concat(imageObj);
        }
      }
    })
    result?.falseCeilingData?.falseCeilingView?.imageData?.forEach((imageObj) => { 
      imageObj.automationType = 'AUTO';
      imageObj.imageName = "FC " + imageObj.name;
        auto = auto.concat(imageObj);  
    })
    let roomImageObj = {
      manual,
      auto,
      raytraced
    }
    return roomImageObj;
  }
  
  function checkDataType(data, type) {
    if (data && Array.isArray(data)) {
      let objArr = []
      for (let d of data) {
        let value = checkDataType(d, type);
        objArr = value ? objArr.concat(value) : objArr;
      }
      return objArr;
    } else if (typeof (data) === 'object') {
      if (data && data.hasOwnProperty(type)) {
        return data;
      } else {
        let objArr = [];
        data && Object.values(data).forEach((obj) => {
          let value = checkDataType(obj, type);
          objArr = value ? objArr.concat(value) : objArr;
        })
        return objArr;
      }
    }
  }

export default function* root() {
    yield takeEvery(ActionTypes.FETCH_MATERIAL_DECK_DATA, getMaterialDeckdata);
    yield takeEvery(ActionTypes.DECK_TIMESTAMP_GENERATION, generateDeckTimestamp);
    yield takeEvery(ActionTypes.DECK_LOG, saveDeckLog);
    yield takeEvery(ActionTypes.UPDATE_MATERIAL_DECK_URL, updateMaterialDeckUrlSaga);
    yield takeEvery(ActionTypes.LEAD_DECK_IMAGES_CHECK, handleLeadDeckImages);
    yield takeEvery(ActionTypes.GET_SCREENSHOTS, getScreenshots);
}                